import {Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild} from '@angular/core';

// import * as nomnoml from 'nomnoml';
import * as nomnoml from 'nomnoml';
import {UntypedFormControl} from '@angular/forms';
import {Table, TableLiteDto} from '@tj/tj-dmp-lib-api';
import * as _ from 'lodash';
import {TableUiService} from './table-ui.service';

@Component({
    selector: 'graph-schema',
    templateUrl: './graph-schema.component.html',
    styleUrls: ['./graph-schema.component.scss'],
    standalone: false
})
export class GraphSchemaComponent implements OnInit, OnChanges {

    public display = false;
    constructor(
        protected tableUiService: TableUiService
    ) {
    }

    @ViewChild('targetCanvas', {static: true}) targetCanvas: ElementRef;
    inputCtrl = new UntypedFormControl('');

    @Input() tables: TableLiteDto[] | Table[];

    @Input() debug = false;

    private linkTable: string[] = [];

    ngOnInit() {
    this.inputCtrl.valueChanges.subscribe(source => {
      this.updateNomnoml(source);
    });
    this.updateNomnoml(this.inputCtrl.value);
  }

  private updateNomnoml(value: string) {
      if (value && value.length > 0) {
          nomnoml.draw(this.targetCanvas.nativeElement, value);
      }
  }


  ngOnChanges(changes: SimpleChanges): void {
      if (changes.tables) {
          this.update();
      }

  }

  private update() {
      if (this.debug) {
          console.log(this.tables);
      }

      const map = this.tableUiService.buildMap(this.tables);

      if (map && map.size > 0) {
          this.linkTable = [];
          this.buildLinks(map);

          this.linkTable = _.uniq(this.linkTable);
          const source = this.linkTable.join('\n');
          this.inputCtrl.setValue(source);
      }
      // maMap.
  }

    private buildLinks(map) {
        if (map && map.size > 0) {
            for (const [key, value] of map) {
                if (value && value.keys()) {
                    //
                    for (const subKey of value.keys()) {
                        this.createLink(key, subKey);
                    }
                    //
                    this.buildLinks(value);
                }
            }
        }
    }

    private createLink(tabA: string, tabB: string, linkType = '') {
        //
        const confTabA = this.tables.find(t => t.code === tabA);
        let descriptionTabA = confTabA.code ? confTabA.code : confTabA.code;
        if (confTabA.description) {
            descriptionTabA += '|' + confTabA.description;
        }
        //
        const confTabB = this.tables.find(t => t.code === tabB);
        if (confTabB != null) {
            let descriptionTabB = confTabB.code ? confTabB.code : confTabB.code;
            if (confTabB.description) {
                descriptionTabB += '|' + confTabB.description;
            }
          //
            this.linkTable.push(`[${descriptionTabA}] ${linkType} <- [${descriptionTabB}]`);
      }

  }


}

